const parseServerChangeLog = (string) => string ? JSON.parse(string.split('=>').join(':').split('nil').join('null')) : {}
export default parseServerChangeLog;


// WEBPACK FOOTER //
// ./src/component/ClaimPage/ClaimHistory/HistoryItem/ActionTypes/parseServerLog.js